/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import type { RefObject, JSX } from 'preact';
import { useState } from 'preact/hooks';
import { classNames } from '#utils/UNSAFE_classNames';
import { overlayControlsContainerStyles } from './themes/TimeComponentStyles.css';
import type { UnpackSignals } from '@oracle/oraclejet-internal-utilities/attributeUtils';

type IntrinsicProps = Pick<UnpackSignals<JSX.IntrinsicElements['div']>, 'children'>;
type Props = IntrinsicProps & {
  innerRef: RefObject<HTMLDivElement>;
};

export function TimeComponentOverlayControlsContainer({ innerRef, children }: Props) {
  const [isVisible, setIsVisible] = useState(false);
  const onControlsShow = () => setIsVisible(true);
  const onControlsHide = () => setIsVisible(false);
  const visibilityProps = { onControlsShow, onControlsHide };

  return (
    <div
      ref={innerRef}
      {...visibilityProps}
      class={classNames([
        overlayControlsContainerStyles.base,
        isVisible && overlayControlsContainerStyles.visible
      ])}>
      {children}
    </div>
  );
}
